export const nationalityList = {
    list: [
        {
            ISO2: "AF",
            nationality: "Afghan"
        },
        {
            ISO2: "AX",
            nationality: "Ål5land Island"
        },
        {
            ISO2: "AL",
            nationality: "Albanian"
        },
        {
            ISO2: "DZ",
            nationality: "Algerian"
        },
        {
            ISO2: "AS",
            nationality: "American Samoan"
        },
        {
            ISO2: "AD",
            nationality: "Andorran"
        },
        {
            ISO2: "AO",
            nationality: "Angolan"
        },
        {
            ISO2: "AI",
            nationality: "Anguillan"
        },
        {
            ISO2: "AQ",
            nationality: "Antarctic"
        },
        {
            ISO2: "AG",
            nationality: "Antiguan or Barbudan"
        },
        {
            ISO2: "AR",
            nationality: "Argentine"
        },
        {
            ISO2: "AM",
            nationality: "Armenian"
        },
        {
            ISO2: "AW",
            nationality: "Aruban"
        },
        {
            ISO2: "AU",
            nationality: "Australian"
        },
        {
            ISO2: "AT",
            nationality: "Austrian"
        },
        {
            ISO2: "AZ",
            nationality: "Azerbaijani, Azeri"
        },
        {
            ISO2: "BS",
            nationality: "Bahamian"
        },
        {
            ISO2: "BH",
            nationality: "Bahraini"
        },
        {
            ISO2: "BD",
            nationality: "Bangladeshi"
        },
        {
            ISO2: "BB",
            nationality: "Barbadian"
        },
        {
            ISO2: "BY",
            nationality: "Belarusian"
        },
        {
            ISO2: "BE",
            nationality: "Belgian"
        },
        {
            ISO2: "BZ",
            nationality: "Belizean"
        },
        {
            ISO2: "BJ",
            nationality: "Beninese, Beninois"
        },
        {
            ISO2: "BM",
            nationality: "Bermudian, Bermudan"
        },
        {
            ISO2: "BT",
            nationality: "Bhutanese"
        },
        {
            ISO2: "BO",
            nationality: "Bolivian"
        },
        {
            ISO2: "BQ",
            nationality: "Bonaire"
        },
        {
            ISO2: "BA",
            nationality: "Bosnian or Herzegovinian"
        },
        {
            ISO2: "BW",
            nationality: "Motswana, Botswanan"
        },
        {
            ISO2: "BV",
            nationality: "Bouvet Island"
        },
        {
            ISO2: "BR",
            nationality: "Brazilian"
        },
        {
            ISO2: "IO",
            nationality: "BIOT"
        },
        {
            ISO2: "BN",
            nationality: "Bruneian"
        },
        {
            ISO2: "BG",
            nationality: "Bulgarian"
        },
        {
            ISO2: "BF",
            nationality: "Burkinabé"
        },
        {
            ISO2: "BI",
            nationality: "Burundian"
        },
        {
            ISO2: "CV",
            nationality: "Cabo Verdean"
        },
        {
            ISO2: "KH",
            nationality: "Cambodian"
        },
        {
            ISO2: "CM",
            nationality: "Cameroonian"
        },
        {
            ISO2: "CA",
            nationality: "Canadian"
        },
        {
            ISO2: "KY",
            nationality: "Caymanian"
        },
        {
            ISO2: "CF",
            nationality: "Central African"
        },
        {
            ISO2: "TD",
            nationality: "Chadian"
        },
        {
            ISO2: "CL",
            nationality: "Chilean"
        },
        {
            ISO2: "CN",
            nationality: "Chinese"
        },
        {
            ISO2: "CX",
            nationality: "Christmas Island"
        },
        {
            ISO2: "CC",
            nationality: "Cocos Island"
        },
        {
            ISO2: "CO",
            nationality: "Colombian"
        },
        {
            ISO2: "KM",
            nationality: "Comoran, Comorian"
        },
        {
            ISO2: "CG",
            nationality: "Congolese"
        },
        {
            ISO2: "CD",
            nationality: "Congolese"
        },
        {
            ISO2: "CK",
            nationality: "Cook Island"
        },
        {
            ISO2: "CR",
            nationality: "Costa Rican"
        },
        {
            ISO2: "CI",
            nationality: "Ivorian"
        },
        {
            ISO2: "HR",
            nationality: "Croatian"
        },
        {
            ISO2: "CU",
            nationality: "Cuban"
        },
        {
            ISO2: "CW",
            nationality: "Curaçaoan"
        },
        {
            ISO2: "CY",
            nationality: "Cypriot"
        },
        {
            ISO2: "CZ",
            nationality: "Czech"
        },
        {
            ISO2: "DK",
            nationality: "Danish"
        },
        {
            ISO2: "DJ",
            nationality: "Djiboutian"
        },
        {
            ISO2: "DM",
            nationality: "Dominican"
        },
        {
            ISO2: "DO",
            nationality: "Dominican"
        },
        {
            ISO2: "EC",
            nationality: "Ecuadorian"
        },
        {
            ISO2: "EG",
            nationality: "Egyptian"
        },
        {
            ISO2: "SV",
            nationality: "Salvadoran"
        },
        {
            ISO2: "GQ",
            nationality: "Equatorial Guinean, Equatoguinean"
        },
        {
            ISO2: "ER",
            nationality: "Eritrean"
        },
        {
            ISO2: "EE",
            nationality: "Estonian"
        },
        {
            ISO2: "ET",
            nationality: "Ethiopian"
        },
        {
            ISO2: "FK",
            nationality: "Falkland Island"
        },
        {
            ISO2: "FO",
            nationality: "Faroese"
        },
        {
            ISO2: "FJ",
            nationality: "Fijian"
        },
        {
            ISO2: "FI",
            nationality: "Finnish"
        },
        {
            ISO2: "FR",
            nationality: "French"
        },
        {
            ISO2: "GF",
            nationality: "French Guianese"
        },
        {
            ISO2: "PF",
            nationality: "French Polynesian"
        },
        {
            ISO2: "TF",
            nationality: "French Southern Territories"
        },
        {
            ISO2: "GA",
            nationality: "Gabonese"
        },
        {
            ISO2: "GM",
            nationality: "Gambian"
        },
        {
            ISO2: "GE",
            nationality: "Georgian"
        },
        {
            ISO2: "DE",
            nationality: "German"
        },
        {
            ISO2: "GH",
            nationality: "Ghanaian"
        },
        {
            ISO2: "GI",
            nationality: "Gibraltar"
        },
        {
            ISO2: "GR",
            nationality: "Greek, Hellenic"
        },
        {
            ISO2: "GL",
            nationality: "Greenlandic"
        },
        {
            ISO2: "GD",
            nationality: "Grenadian"
        },
        {
            ISO2: "GP",
            nationality: "Guadeloupe"
        },
        {
            ISO2: "GU",
            nationality: "Guamanian, Guambat"
        },
        {
            ISO2: "GT",
            nationality: "Guatemalan"
        },
        {
            ISO2: "GG",
            nationality: "Channel Island"
        },
        {
            ISO2: "GN",
            nationality: "Guinean"
        },
        {
            ISO2: "GW",
            nationality: "Bissau-Guinean"
        },
        {
            ISO2: "GY",
            nationality: "Guyanese"
        },
        {
            ISO2: "HT",
            nationality: "Haitian"
        },
        {
            ISO2: "HM",
            nationality: "Heard Island or McDonald Islands"
        },
        {
            ISO2: "VA",
            nationality: "Vatican"
        },
        {
            ISO2: "HN",
            nationality: "Honduran"
        },
        {
            ISO2: "HK",
            nationality: "Hong Kong, Hong Kongese"
        },
        {
            ISO2: "HU",
            nationality: "Hungarian, Magyar"
        },
        {
            ISO2: "IS",
            nationality: "Icelandic"
        },
        {
            ISO2: "IN",
            nationality: "Indian"
        },
        {
            ISO2: "ID",
            nationality: "Indonesian"
        },
        {
            ISO2: "IR",
            nationality: "Iranian, Persian"
        },
        {
            ISO2: "IQ",
            nationality: "Iraqi"
        },
        {
            ISO2: "IE",
            nationality: "Irish"
        },
        {
            ISO2: "IM",
            nationality: "Manx"
        },
        {
            ISO2: "IL",
            nationality: "Israeli"
        },
        {
            ISO2: "IT",
            nationality: "Italian"
        },
        {
            ISO2: "JM",
            nationality: "Jamaican"
        },
        {
            ISO2: "JP",
            nationality: "Japanese"
        },
        {
            ISO2: "JE",
            nationality: "Channel Island"
        },
        {
            ISO2: "JO",
            nationality: "Jordanian"
        },
        {
            ISO2: "KZ",
            nationality: "Kazakhstani, Kazakh"
        },
        {
            ISO2: "KE",
            nationality: "Kenyan"
        },
        {
            ISO2: "KI",
            nationality: "I-Kiribati"
        },
        {
            ISO2: "KP",
            nationality: "North Korean"
        },
        {
            ISO2: "KR",
            nationality: "South Korean"
        },
        {
            ISO2: "KW",
            nationality: "Kuwaiti"
        },
        {
            ISO2: "KG",
            nationality: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"
        },
        {
            ISO2: "LA",
            nationality: "Lao, Laotian"
        },
        {
            ISO2: "LV",
            nationality: "Latvian"
        },
        {
            ISO2: "LB",
            nationality: "Lebanese"
        },
        {
            ISO2: "LS",
            nationality: "Basotho"
        },
        {
            ISO2: "LR",
            nationality: "Liberian"
        },
        {
            ISO2: "LY",
            nationality: "Libyan"
        },
        {
            ISO2: "LI",
            nationality: "Liechtenstein"
        },
        {
            ISO2: "LT",
            nationality: "Lithuanian"
        },
        {
            ISO2: "LU",
            nationality: "Luxembourg, Luxembourgish"
        },
        {
            ISO2: "MO",
            nationality: "Macanese, Chinese"
        },
        {
            ISO2: "MK",
            nationality: "Macedonian"
        },
        {
            ISO2: "MG",
            nationality: "Malagasy"
        },
        {
            ISO2: "MW",
            nationality: "Malawian"
        },
        {
            ISO2: "MY",
            nationality: "Malaysian"
        },
        {
            ISO2: "MV",
            nationality: "Maldivian"
        },
        {
            ISO2: "ML",
            nationality: "Malian, Malinese"
        },
        {
            ISO2: "MT",
            nationality: "Maltese"
        },
        {
            ISO2: "MH",
            nationality: "Marshallese"
        },
        {
            ISO2: "MQ",
            nationality: "Martiniquais, Martinican"
        },
        {
            ISO2: "MR",
            nationality: "Mauritanian"
        },
        {
            ISO2: "MU",
            nationality: "Mauritian"
        },
        {
            ISO2: "YT",
            nationality: "Mahoran"
        },
        {
            ISO2: "MX",
            nationality: "Mexican"
        },
        {
            ISO2: "FM",
            nationality: "Micronesian"
        },
        {
            ISO2: "MD",
            nationality: "Moldovan"
        },
        {
            ISO2: "MC",
            nationality: "Monégasque, Monacan"
        },
        {
            ISO2: "MN",
            nationality: "Mongolian"
        },
        {
            ISO2: "ME",
            nationality: "Montenegrin"
        },
        {
            ISO2: "MS",
            nationality: "Montserratian"
        },
        {
            ISO2: "MA",
            nationality: "Moroccan"
        },
        {
            ISO2: "MZ",
            nationality: "Mozambican"
        },
        {
            ISO2: "MM",
            nationality: "Burmese"
        },
        {
            ISO2: "NA",
            nationality: "Namibian"
        },
        {
            ISO2: "NR",
            nationality: "Nauruan"
        },
        {
            ISO2: "NP",
            nationality: "Nepali, Nepalese"
        },
        {
            ISO2: "NL",
            nationality: "Dutch, Netherlandic"
        },
        {
            ISO2: "NC",
            nationality: "New Caledonian"
        },
        {
            ISO2: "NZ",
            nationality: "New Zealand, NZ"
        },
        {
            ISO2: "NI",
            nationality: "Nicaraguan"
        },
        {
            ISO2: "NE",
            nationality: "Nigerien"
        },
        {
            ISO2: "NG",
            nationality: "Nigerian"
        },
        {
            ISO2: "NU",
            nationality: "Niuean"
        },
        {
            ISO2: "NF",
            nationality: "Norfolk Island"
        },
        {
            ISO2: "MP",
            nationality: "Northern Marianan"
        },
        {
            ISO2: "NO",
            nationality: "Norwegian"
        },
        {
            ISO2: "OM",
            nationality: "Omani"
        },
        {
            ISO2: "PK",
            nationality: "Pakistani"
        },
        {
            ISO2: "PW",
            nationality: "Palauan"
        },
        {
            ISO2: "PS",
            nationality: "Palestinian"
        },
        {
            ISO2: "PA",
            nationality: "Panamanian"
        },
        {
            ISO2: "PG",
            nationality: "Papua New Guinean, Papuan"
        },
        {
            ISO2: "PY",
            nationality: "Paraguayan"
        },
        {
            ISO2: "PE",
            nationality: "Peruvian"
        },
        {
            ISO2: "PH",
            nationality: "Philippine, Filipino"
        },
        {
            ISO2: "PN",
            nationality: "Pitcairn Island"
        },
        {
            ISO2: "PL",
            nationality: "Polish"
        },
        {
            ISO2: "PT",
            nationality: "Portuguese"
        },
        {
            ISO2: "PR",
            nationality: "Puerto Rican"
        },
        {
            ISO2: "QA",
            nationality: "Qatari"
        },
        {
            ISO2: "RE",
            nationality: "Réunionese, Réunionnais"
        },
        {
            ISO2: "RO",
            nationality: "Romanian"
        },
        {
            ISO2: "RU",
            nationality: "Russian"
        },
        {
            ISO2: "RW",
            nationality: "Rwandan"
        },
        {
            ISO2: "BL",
            nationality: "Barthélemois"
        },
        {
            ISO2: "SH",
            nationality: "Saint Helenian"
        },
        {
            ISO2: "KN",
            nationality: "Kittitian or Nevisian"
        },
        {
            ISO2: "LC",
            nationality: "Saint Lucian"
        },
        {
            ISO2: "MF",
            nationality: "Saint-Martinoise"
        },
        {
            ISO2: "PM",
            nationality: "Saint-Pierrais or Miquelonnais"
        },
        {
            ISO2: "VC",
            nationality: "Saint Vincentian, Vincentian"
        },
        {
            ISO2: "WS",
            nationality: "Samoan"
        },
        {
            ISO2: "SM",
            nationality: "Sammarinese"
        },
        {
            ISO2: "ST",
            nationality: "São Toméan"
        },
        {
            ISO2: "SA",
            nationality: "Saudi, Saudi Arabian"
        },
        {
            ISO2: "SN",
            nationality: "Senegalese"
        },
        {
            ISO2: "RS",
            nationality: "Serbian"
        },
        {
            ISO2: "SC",
            nationality: "Seychellois"
        },
        {
            ISO2: "SL",
            nationality: "Sierra Leonean"
        },
        {
            ISO2: "SG",
            nationality: "Singaporean"
        },
        {
            ISO2: "SX",
            nationality: "Sint Maarten"
        },
        {
            ISO2: "SK",
            nationality: "Slovak"
        },
        {
            ISO2: "SI",
            nationality: "Slovenian, Slovene"
        },
        {
            ISO2: "SB",
            nationality: "Solomon Island"
        },
        {
            ISO2: "SO",
            nationality: "Somali, Somalian"
        },
        {
            ISO2: "ZA",
            nationality: "South African"
        },
        {
            ISO2: "GS",
            nationality: "South Georgia or South Sandwich Islands"
        },
        {
            ISO2: "SS",
            nationality: "South Sudanese"
        },
        {
            ISO2: "ES",
            nationality: "Spanish"
        },
        {
            ISO2: "LK",
            nationality: "Sri Lankan"
        },
        {
            ISO2: "SD",
            nationality: "Sudanese"
        },
        {
            ISO2: "SR",
            nationality: "Surinamese"
        },
        {
            ISO2: "SJ",
            nationality: "Svalbard"
        },
        {
            ISO2: "SZ",
            nationality: "Swazi"
        },
        {
            ISO2: "SE",
            nationality: "Swedish"
        },
        {
            ISO2: "CH",
            nationality: "Swiss"
        },
        {
            ISO2: "SY",
            nationality: "Syrian"
        },
        {
            ISO2: "TW",
            nationality: "Chinese, Taiwanese"
        },
        {
            ISO2: "TJ",
            nationality: "Tajikistani"
        },
        {
            ISO2: "TZ",
            nationality: "Tanzanian"
        },
        {
            ISO2: "TH",
            nationality: "Thai"
        },
        {
            ISO2: "TL",
            nationality: "Timorese"
        },
        {
            ISO2: "TG",
            nationality: "Togolese"
        },
        {
            ISO2: "TK",
            nationality: "Tokelauan"
        },
        {
            ISO2: "TO",
            nationality: "Tongan"
        },
        {
            ISO2: "TT",
            nationality: "Trinidadian or Tobagonian"
        },
        {
            ISO2: "TN",
            nationality: "Tunisian"
        },
        {
            ISO2: "TR",
            nationality: "Turkish"
        },
        {
            ISO2: "TM",
            nationality: "Turkmen"
        },
        {
            ISO2: "TC",
            nationality: "Turks and Caicos Island"
        },
        {
            ISO2: "TV",
            nationality: "Tuvaluan"
        },
        {
            ISO2: "UG",
            nationality: "Ugandan"
        },
        {
            ISO2: "UA",
            nationality: "Ukrainian"
        },
        {
            ISO2: "AE",
            nationality: "Emirati, Emirian, Emiri"
        },
        {
            ISO2: "GB",
            nationality: "British, UK"
        },
        {
            ISO2: "US",
            nationality: "American"
        },
        {
            ISO2: "UY",
            nationality: "Uruguayan"
        },
        {
            ISO2: "UZ",
            nationality: "Uzbekistani, Uzbek"
        },
        {
            ISO2: "VU",
            nationality: "Ni-Vanuatu, Vanuatuan"
        },
        {
            ISO2: "VE",
            nationality: "Venezuelan"
        },
        {
            ISO2: "VN",
            nationality: "Vietnamese"
        },
        {
            ISO2: "VG",
            nationality: "British Virgin Island"
        },
        {
            ISO2: "VI",
            nationality: "U.S. Virgin Island"
        },
        {
            ISO2: "WF",
            nationality: "Wallis and Futuna, Wallisian or Futunan"
        },
        {
            ISO2: "EH",
            nationality: "Sahrawi, Sahrawian, Sahraouian"
        },
        {
            ISO2: "YE",
            nationality: "Yemeni"
        },
        {
            ISO2: "ZM",
            nationality: "Zambian"
        },
        {
            ISO2: "ZW",
            nationality: "Zimbabwean"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/app/utilities/nationalityList.ts